<div class="login-wrapper">
  <div class="login-content">
    <h2 class="title">Sign up</h2>
    <ul class="btns-group">
      <li>
        <a routerLink="/sign-up/customer">
          <div class="menu">
            <button class="arrow-btn"><img src="assets/images/menu/person-outline.svg" alt="user"></button>
            <p class="name">Continue as Customer</p>
          </div>
          <button class="arrow-btn no-bg"><img src="assets/images/booking/right-arrow.svg" alt="right arrow"></button>
        </a>
      </li>
      <li>
        <a routerLink="/business/provider/signup">
          <div class="menu">
            <button class="arrow-btn"><img src="assets/images/menu/briefcase.svg" alt="business"></button>
            <p class="name">Continue as Business</p>
          </div>
          <button class="arrow-btn no-bg"><img src="assets/images/booking/right-arrow.svg" alt="right arrow"></button>
        </a>
      </li>
    </ul>
  </div>
</div>
